<template>
  <Breadcrumb :product="data"/>
  <Buybox :product="data"/>
  <ProductStickyBar :product="data"/>
</template>

<script setup>
  import { onMounted, onUnmounted } from 'vue';
  import { useStore } from 'vuex';
  import Breadcrumb from './components/breadcrumb.vue';
  import Buybox from './components/buybox.vue';
  import ProductStickyBar from './components/product-sticky-bar.vue';

  const props = defineProps({
    data: {
      type: Object,
      default: () => ({}),
    },
  });

  const store = useStore();

  onMounted(() => {
    store.dispatch('fetchWishlistItems');
    window.addEventListener('refreshWishlist', refreshWishlist);
  })

  onUnmounted(() => {
    window.removeEventListener('refreshWishlist', refreshWishlist);
  });

  const refreshWishlist = () => {
    store.dispatch('fetchWishlistItems');
  };

</script>
